import { SiteTypes } from '../enums';

export const getRetailUnitAndLanguage = () => {
  const { pathname } = globalThis.location;
  const pathParams = pathname.split('/');
  pathParams.shift();
  const [retailUnit, language] = pathParams;
  return { retailUnit, language };
};

export const getOrigin = globalThis.location.origin;

export const getEndpointURL = (siteType: SiteTypes, route?: string) => {
  const { retailUnit, language } = getRetailUnitAndLanguage();

  const origin = getOrigin;
  const formattedRoute = route ? `${route}/` : '';

  return `${origin}/${retailUnit}/${language}/${siteType}/${formattedRoute}`;
};
